namespace ui
{
	export namespace Form
	{

		export class InputTypeahead<TITEM = any>
			extends Input<ITypeaheadDescriptor>
		{
			private		m_Item: TITEM|null;

			public constructor( descriptor: ITypeaheadDescriptor )
			{
				super( null, descriptor, 'text', InputValueTypes.ANY );

				this.m_Item		= null;
			}

			public Initialize(): void
			{
				super.Initialize();

				this.m_Root.addClass( 'typeahead' );
				this.m_Root.attr( 'contenteditable', 'true' );
			}

			public Source( data: any[] ): InputTypeahead<TITEM>
			{
				// @ts-ignore
				this.m_Root.typeahead(
					{
						afterSelect: ( item: TITEM|null ) => { this.Descriptor.afterSelect( item ); this.m_Item = item; },
						displayText: this.Descriptor.displayText,
						fitToElement: true,
						source: data,
					}
				);

				return this;
			}

			public val(): TITEM|null
			{
				return this.m_Item;
			}

			public value( value: TITEM|null ): InputTypeahead<TITEM>
			{
				this.m_Item	= value;

				return this;
			}

			public reset(): InputTypeahead<TITEM>
			{
				this.value( this.Default );
				this.m_Root.html( '' );

				return this;
			}

		}

	}
}
